// Same prefixes as the api (utils/phoneNumber.js, OVERSEAS_COUNTRY_CODES): a French
// overseas number filed in the national format with France selected comes out
// as +33, and only its national prefix tells the real calling code.
const OVERSEAS_CALLING_CODES = {
  590: '590', 690: '590', 691: '590',
  596: '596', 696: '596', 697: '596',
  594: '594', 694: '594',
  262: '262', 692: '262', 693: '262', 269: '262', 639: '262',
};
const E164_PATTERN = /^\+[1-9]\d{6,14}$/;
const NATIONAL_PATTERN = /^0[1-9]\d{8}$/;

const correctOverseasNumber = (phone) => {
  const match = /^\+33(\d{3})(\d{6})$/.exec(phone);
  const callingCode = match && OVERSEAS_CALLING_CODES[match[1]];
  return callingCode ? `+${callingCode}${match[1]}${match[2]}` : phone;
};

// react-phone-number-input logs an error for any value that is not E.164,
// a stored number can carry spaces or be missing, and the CRM files a
// prospect's number in the national format (« 0596 61 00 14 »), which the
// field would otherwise hold as invalid.
export const toPhoneValue = (raw) => {
  const compact = typeof raw === 'string' ? raw.replace(/[\s.\-()/]/g, '') : '';
  if (NATIONAL_PATTERN.test(compact)) return correctOverseasNumber(`+33${compact.slice(1)}`);
  return E164_PATTERN.test(compact) ? correctOverseasNumber(compact) : undefined;
};
